﻿$.fn.dxCtrlBuilderEmailStyleBloc = function custom_dxCtrlBuilderEmailStyleBloc(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylebloc dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleBloc(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleBloc = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()


        //blocwiddget: jsonCssDataBloc,
        //    blocwidgetinner: jsonCssDataBlocInner,

        if (option.showAlign) {
            //$("<br/>").appendTo(container)
            $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Alignement du contenu:</div>").appendTo(container)
            $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleAlignement({
                allowDefaut: option.allowDefaut,
                value: option.blocwidget["text-align"],
                onValueChanged: function (e) {
                    option.onValueChanged(e)
                }
            })
        }


        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Couleur arrière plan:</div>").appendTo(container)
        $("<div  style='margin:0 0;'/>").appendTo(container).dxCtrlColorPicker({
            value: option.blocwidgetinner["background-color"],
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                var newValue = e.value
                option.onValueChanged({ values_inner: [{ prop: "background-color", value: newValue, oldValue: option.blocwidgetinner["background-color"] }] })
                option.blocwidgetinner["background-color"] = newValue
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Marge extérieure:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStylePadding({
            type: "padding",
            allowDefaut: option.allowDefaut,
            padTop: option.blocwidget["padding-top"].replace("px", ""),
            padBottom: option.blocwidget["padding-bottom"].replace("px", ""),
            padLeft: option.blocwidget["padding-left"].replace("px", ""),
            padRight: option.blocwidget["padding-right"].replace("px", ""),
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Marge intérieure:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStylePadding({
            type: "padding",
            allowDefaut: option.allowDefaut,
            padTop: option.blocwidgetinner["padding-top"].replace("px", ""),
            padBottom: option.blocwidgetinner["padding-bottom"].replace("px", ""),
            padLeft: option.blocwidgetinner["padding-left"].replace("px", ""),
            padRight: option.blocwidgetinner["padding-right"].replace("px", ""),
            onValueChanged: function (e) {
                e.values_inner = e.values
                delete e.values
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Bordure du bloc:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: option.allowDefaut,
            borderWidth: option.blocwidgetinner["border-width"],
            borderStyle: option.blocwidgetinner["border-style"],
            borderColor: option.blocwidgetinner["border-color"],
            onValueChanged: function (e) {
                e.values_inner = e.values
                delete e.values
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Forme du bloc:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleRadius({
            allowDefaut: option.allowDefaut,
            radiusTopRight: option.blocwidgetinner["border-top-right-radius"],
            radiusTopLeft: option.blocwidgetinner["border-top-left-radius"],
            radiusBottomRight: option.blocwidgetinner["border-bottom-right-radius"],
            radiusBottomLeft: option.blocwidgetinner["border-bottom-left-radius"],
            onValueChanged: function (e) {
                e.values_inner = e.values
                delete e.values
                option.onValueChanged(e)
            }
        })

        //$("<br/>").appendTo(container)
        //$("<br/>").appendTo(container)
        //$("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Coins arrondis:</div>").appendTo(container)
        //$("<div/>").appendTo(container).dxCtrlBuilderEmailStyleBordure({
        //    dxBuilderEmailPage: option.dxBuilderEmailPage,
        //    allowDefaut: option.allowDefaut,
        //    borderWidth: option.blocwidgetinner["border-width"],
        //    borderStyle: option.blocwidgetinner["border-style"],
        //    borderColor: option.blocwidgetinner["border-color"],
        //    onValueChanged: function (e) {
        //        e.values_inner = e.values
        //        delete e.values
        //        option.onValueChanged(e)
        //    }
        //})
    }

    this.element = function () { return container }

    mConstruit();
}